import React, { useState } from "react";
import PropTypes from "prop-types";

import { Label, Field, Control, Input } from "rbx";
import { addDays } from "date-fns";
import FilterButtons from "../../../components/FilterButtons";

import { SystemCodeSelect, EmployeeSelect } from "../../../components/inputs";

const INITIAL_FILTER_STATE = {
  CertificationTypeRecIdRef_not: 45,
  ExpirationDate_gte: addDays(new Date(), -90),
  minDaysToExpire: -90,
  EmployeeTypeRecIdRef: null
};

const EmployeeCertificationFilters = ({ filters, onFilter, onClose }) => {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const newFilters = {
      ...inputs
    };
    const isExpiratory =
      e.target.name === "maxDaysToExpire" ||
      e.target.name === "minDaysToExpire";
    if (!value) {
      const keys = isExpiratory
        ? Object.keys(inputs).filter(key => {
            if (e.target.name === "maxDaysToExpire") {
              return key !== "maxDaysToExpire" && key !== "ExpirationDate_lte";
            }
            return key !== "minDaysToExpire" && key !== "ExpirationDate_gte";
          })
        : Object.keys(inputs).filter(key => key !== e.target.name);

      setInputs({
        ...keys.reduce((acc, curr) => ({ [curr]: inputs[curr] }), {})
      });
    } else {
      if (isExpiratory) {
        const dte = e.target.value ? parseInt(e.target.value) : null;
        const expirationDate = addDays(new Date(), dte);
        newFilters[e.target.name] = dte;
        newFilters[
          e.target.name === "maxDaysToExpire"
            ? "ExpirationDate_lte"
            : "ExpirationDate_gte"
        ] = expirationDate;
      } else if (
        e.target.name === "CertificationTypeRecIdRef" ||
        e.target.name === "EmployeeRecIdRef"
      ) {
        const v = parseInt(value);
        newFilters[e.target.name] = v !== 0 ? v : null;
      } else {
        newFilters[e.target.name] = value;
      }

      setInputs(newFilters);
    }
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <React.Fragment>
      <Field kind="group">
        <Control>
          <EmployeeSelect
            icon="user"
            label="Employee"
            name="EmployeeRecIdRef"
            value={inputs.EmployeeRecIdRef}
            onChange={handleChange}
          />
        </Control>
        <Control expanded>
          <SystemCodeSelect
            icon="globe"
            label="Employee Type"
            lookup={{
              Category: "Employee",
              Code: "EmployeeType"
            }}
            name="EmployeeTypeRecIdRef"
            value={inputs.EmployeeTypeRecIdRef}
            onChange={handleChange}
          />
        </Control>
      </Field>
      <Field kind="group">
        <Control expanded>
          <SystemCodeSelect
            icon="certificate"
            label="Certification Type"
            lookup={{ Category: "Employee", Code: "Certifications" }}
            name="CertificationTypeRecIdRef"
            showHelp={false}
            value={inputs.CertificationTypeRecIdRef}
            onChange={handleChange}
          />
        </Control>
      </Field>
      <Field kind="group">
        <Control>
          <Label>Min. Days to Expire</Label>
          <Input
            name="minDaysToExpire"
            type="number"
            value={inputs.minDaysToExpire}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Max. Days to Expire</Label>
          <Input
            name="maxDaysToExpire"
            type="number"
            value={inputs.maxDaysToExpire}
            onChange={handleChange}
          />
        </Control>
      </Field>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </React.Fragment>
  );
};

EmployeeCertificationFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};

export default EmployeeCertificationFilters;
